let _ = t => t,
  _t,
  _t2;
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import breakpoint, { breakpointValues } from '../../../constants/Breakpoints';
import { SegmentedTabNavItems } from '../../../constants/routing/NavItems';
import { usePageParams } from '../../../hooks/usePageParams';
import { shouldShowInAppUiSelector } from '../../../selectors/GatingSelectors';
import SegmentedTabs from './SegmentedTabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFlex = styled(UIFlex).withConfig({
  displayName: "SegmentedTabsLayout__StyledFlex",
  componentId: "te7dac-0"
})(["padding:0;margin:0 auto;max-width:1330px;position:relative;align-items:center;display:flex;"]);
const SegmentedTabsContainer = styled.div.withConfig({
  displayName: "SegmentedTabsLayout__SegmentedTabsContainer",
  componentId: "te7dac-1"
})(["max-width:1130px;width:100%;margin:0 18px;display:flex;justify-content:center;align-self:flex-end;@media (min-width:", "px) and (max-width:", "px){max-width:1008px;}@media (min-width:", "px) and (max-width:", "px){max-width:776px;}@media (min-width:", "px) and (max-width:", "px){max-width:650px;margin:0 10px;}", ";"], breakpointValues.sdMac, breakpointValues.sd - 1, breakpointValues.tablet, breakpointValues.sdMac - 1, breakpointValues.tabletPortrait, breakpointValues.tablet - 1, breakpoint.tabletPortrait(_t || (_t = _`
    margin: 0 auto;
  `)));
const StyledButton = styled(UIButton).withConfig({
  displayName: "SegmentedTabsLayout__StyledButton",
  componentId: "te7dac-2"
})(["min-width:200px;margin-right:36px;white-space:nowrap !important;@media (min-width:", "px) and (max-width:", "px){min-width:178px;}@media (min-width:", "px) and (max-width:", "px){min-width:110px;}", ""], breakpointValues.tablet, breakpointValues.sdMac - 1, breakpointValues.tabletPortrait, breakpointValues.tablet - 1, breakpoint.tablet(_t2 || (_t2 = _`
    margin-right: 34px;
  `)));
const SegmentedTabsLayout = ({
  isIntersecting = false,
  selectedNavItem
}) => {
  const showingInAppUi = useSelector(shouldShowInAppUiSelector);
  const hideTabs = showingInAppUi || !SegmentedTabNavItems.includes(selectedNavItem);
  const {
    tab
  } = usePageParams();
  const history = useHistory();
  return /*#__PURE__*/_jsxs(StyledFlex, {
    children: [/*#__PURE__*/_jsxs(StyledButton, {
      use: "link",
      onClick: () => {
        history.push(hideTabs ? '/splash' : `/splash/${tab}`);
      },
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "left",
        size: 28,
        color: "inherit",
        className: "m-right-0",
        style: {
          verticalAlign: 'middle'
        }
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.sidenav.backToOverview"
      })]
    }), !hideTabs && /*#__PURE__*/_jsx(SegmentedTabsContainer, {
      children: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(SegmentedTabs, {
          bordered: !hideTabs && isIntersecting,
          selectedTab: tab,
          path: `/${selectedNavItem}`
        })
      })
    })]
  });
};
export default SegmentedTabsLayout;